var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 356,
    height: 146,
    viewBox: "0 0 356 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 356,
    height: 146
  }, /*#__PURE__*/React.createElement("rect", {
    width: 356,
    height: 146,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.9531 52.4303C91.9709 51.9524 91.9799 51.4722 91.9799 50.9899C91.9799 30.0087 74.9712 13 53.9899 13C33.0087 13 16 30.0087 16 50.9899C16 71.9712 33.0087 88.9799 53.9899 88.9799C67.771 88.9799 79.8383 81.642 86.4976 70.6601C93.7064 74.4479 103.632 65.5364 106 61.3919C91.9392 64.4677 91.9666 56.4435 91.9795 52.6667C91.9799 52.5562 91.9803 52.4494 91.9803 52.3466L91.9531 52.4303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.9531 52.4303L91.4534 52.4117L92.4286 52.5848L91.9531 52.4303ZM86.4976 70.6601L86.7301 70.2175L86.3139 69.9988L86.07 70.4009L86.4976 70.6601ZM106 61.3919L106.435 61.6399L106.993 60.6629L105.894 60.9034L106 61.3919ZM91.9795 52.6667L92.4795 52.6684V52.6684L91.9795 52.6667ZM91.9803 52.3466H92.4803L91.5048 52.1921L91.9803 52.3466ZM91.4799 50.9899C91.4799 51.466 91.471 51.94 91.4534 52.4117L92.4528 52.4489C92.4708 51.9648 92.4799 51.4784 92.4799 50.9899H91.4799ZM53.9899 13.5C74.6951 13.5 91.4799 30.2848 91.4799 50.9899H92.4799C92.4799 29.7325 75.2474 12.5 53.9899 12.5V13.5ZM16.5 50.9899C16.5 30.2848 33.2848 13.5 53.9899 13.5V12.5C32.7325 12.5 15.5 29.7325 15.5 50.9899H16.5ZM53.9899 88.4799C33.2848 88.4799 16.5 71.6951 16.5 50.9899H15.5C15.5 72.2474 32.7325 89.4799 53.9899 89.4799V88.4799ZM86.07 70.4009C79.4976 81.2395 67.5891 88.4799 53.9899 88.4799V89.4799C67.953 89.4799 80.1789 82.0444 86.9251 70.9194L86.07 70.4009ZM86.265 71.1027C90.1134 73.1249 94.6073 71.7239 98.327 69.426C102.062 67.1185 105.201 63.798 106.435 61.6399L105.566 61.1438C104.431 63.1303 101.423 66.3378 97.8014 68.5752C94.1639 70.8223 90.0905 71.9832 86.7301 70.2175L86.265 71.1027ZM105.894 60.9034C98.9262 62.4275 95.6638 61.1552 94.0959 59.2785C92.4821 57.3468 92.473 54.591 92.4795 52.6684L91.4795 52.665C91.4732 54.5192 91.4439 57.6639 93.3285 59.9196C95.2589 62.2302 99.0134 63.4321 106.107 61.8803L105.894 60.9034ZM92.4795 52.6684C92.4799 52.5581 92.4803 52.4504 92.4803 52.3466H91.4803C91.4803 52.4484 91.4799 52.5543 91.4795 52.665L92.4795 52.6684ZM91.5048 52.1921L91.4776 52.2757L92.4286 52.5848L92.4558 52.5012L91.5048 52.1921Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.088 151.27C128.391 151.27 139.175 148.637 139.175 145.389C139.175 142.141 128.391 139.508 115.088 139.508C101.784 139.508 91 142.141 91 145.389C91 148.637 101.784 151.27 115.088 151.27Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.175 145.389H91V154.931H139.175V145.389Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.834 160.842C153.834 160.842 149.066 182.31 159.172 181.525C169.283 180.741 169.806 183.227 170.195 179.167C170.59 175.111 174.646 139.764 174.646 139.764C174.646 139.764 177.917 119.604 145.451 121.439C145.451 121.439 127.004 120.916 128.439 116.989L124.245 123.403L122.02 124.972L152.127 144.066L153.834 160.842Z",
    fill: "#161F44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.29 134.047C100.29 134.047 95.6393 148.932 138.195 147.163C138.195 147.163 151.09 144.22 140.354 157.571C140.354 157.571 117.184 185.976 138.129 186.632C138.129 186.632 146.768 187.939 148.993 183.489C151.218 179.039 160.775 154.951 160.775 154.951C160.775 154.951 171.901 134.529 156.72 131.386C141.533 128.243 123.47 126.018 124.254 123.403C125.034 120.783 100.29 134.047 100.29 134.047Z",
    fill: "#1C2352"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.179 127.264L150.302 128.336C150.302 128.336 153.967 129.254 154.624 132.273C155.28 135.293 151.906 132.925 149.553 132.925C147.2 132.925 143.205 130.207 143.205 130.207L146.179 127.264Z",
    fill: "#FAB07E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.376 123.06L162.401 124.439C162.401 124.439 165.98 125.634 166.39 128.623C166.8 131.612 163.631 129.033 161.283 128.838C158.935 128.643 155.172 125.675 155.172 125.675L158.376 123.06Z",
    fill: "#FAB07E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.446 73.1053C141.446 73.1053 144.769 85.508 145.164 93.1629C145.558 100.818 148.896 111.523 156.161 117.317C163.427 123.111 155.28 126.741 155.28 126.741C155.28 126.741 153.905 129.294 148.112 122.029C142.318 114.764 140.129 115.056 138.652 107.304C137.18 99.5463 130.536 118.102 143.887 123.701C143.887 123.701 149.481 125.957 144.671 129.787C139.862 133.617 139.395 128.336 132.817 125.957C126.475 123.665 113.452 130.079 113.452 130.079C113.452 130.079 100.295 136.657 98.8238 133.022C97.3523 129.387 97.4498 96.9417 102.556 88.4459C107.663 79.9501 118.364 63.1995 129.264 62.9124L133.781 62.6611L141.446 73.1053Z",
    fill: "#85839E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.577 60.5334C135.577 60.5334 136.772 62.1075 140.504 60.5334C144.237 58.9594 149.636 51.6787 149.636 51.6787L160.941 48.5358C160.941 48.5358 167.509 46.4746 158.034 40.8296C148.559 35.1845 145.662 34.1539 138.546 38.7684C138.546 38.7684 130.153 38.4249 130.937 47.6539C131.721 56.8829 131.434 56.8213 135.577 60.5334Z",
    fill: "#AEAEAE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.921 63.8302C134.182 67.0912 138.489 77.8173 141.139 73.5925C146.636 64.8198 148.733 67.5731 148.733 67.5731C158.864 75.5049 162.453 48.5922 160.643 48.1C158.387 44.9929 157.47 47.4796 153.183 46.2337C148.897 44.9877 148.928 50.5559 148.502 51.9915C148.077 53.4323 148.897 54.0219 144.739 53.5963C140.581 53.1708 142.806 58.6364 142.806 58.6364C140.104 60.9539 135.833 62.1793 133.772 62.6612C133.777 62.6612 132.444 62.5997 132.921 63.8302Z",
    fill: "#F9A876"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.39 75.7676C238.39 75.7676 241.066 78.6901 241.287 79.2285C241.507 79.7668 241.477 81.0692 242 82.2484C242.523 83.4277 242.538 83.6481 242.538 83.6481L239.615 85.0735L239.431 84.8069L236.498 75.9214C236.503 75.9163 237.088 75.3523 238.39 75.7676Z",
    fill: "#FFB59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.351 106.181C228.351 106.181 225.114 109.286 222.601 108.888C220.094 108.49 217.285 110.324 222.413 111.21L226.992 111.216C226.992 111.216 228.482 111.065 231.652 108.207C231.652 108.207 233.404 106.705 235.865 109.238L237.27 103.28C237.27 103.28 233.005 101.646 231.235 102.713C229.465 103.781 225.37 102.665 224.617 103.666C223.863 104.673 227.774 104.661 228.203 105.18C228.203 105.18 228.682 105.566 228.351 106.181Z",
    fill: "#FFB59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.848 104.387C257.848 104.387 238.888 102.162 237.308 102.947C235.729 103.731 233.766 110.54 238.606 111.719C243.451 112.899 261.253 115.211 261.253 115.211L257.848 104.387Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.968 85.0681L224.341 91.1336L209.415 58.6373L226.181 56.5608L240.968 85.0681Z",
    fill: "#223367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.341 91.1334L223.828 92.1588L208.903 59.6625L209.415 58.6371L224.341 91.1334Z",
    fill: "#646F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.455 86.0937L223.827 92.1592L224.34 91.1337L240.968 85.0682L240.455 86.0937Z",
    fill: "#646F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.092 82.6789L224.756 87.4267L211.851 59.3193L225.12 57.6786L238.092 82.6789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.363 57.7505L217.301 59.222L221.475 58.658L220.808 57.2019L220.911 55.838L216.363 56.5251V57.7505Z",
    fill: "#646F87"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.437 84.8014C238.909 82.6941 239.078 83.0838 238.001 81.8071C236.919 80.5304 236.227 78.7154 235.986 77.5105C235.73 76.2185 234.709 73.7574 234.709 73.7574C234.709 73.7574 234.479 71.8911 237.073 75.916L239.437 79.4025L240.806 83.776L239.437 84.8014Z",
    fill: "#FFB59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.539 70.2865C263.539 70.2865 268.123 60.4012 275.844 61.9753C275.844 61.9753 286.053 66.195 291.944 79.7462C297.835 93.2974 297.835 115.211 297.835 115.211H254.31C254.31 115.211 252.244 115.975 249.906 111.591C247.568 107.208 237.682 87.8985 237.682 87.8985C237.682 87.8985 236.636 86.8525 238.011 86.0014C239.385 85.1503 242.066 81.2895 244.097 84.8888C246.127 88.4881 252.72 96.5891 252.72 96.5891C252.72 96.5891 254.684 100.517 256.007 92.9539C257.34 85.3912 263.539 70.2865 263.539 70.2865Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.152 41.7793C252.152 41.7793 250.568 58.9135 260.458 63.9853C260.765 64.0929 261.581 64.2775 261.857 64.2673C262.688 64.2365 264.518 64.0058 265.882 62.6471C265.882 62.6471 268.497 64.4262 268.989 66.9283C269.482 69.4304 274.342 62.3651 274.686 61.4781C274.686 61.4781 268.338 54.4948 269.958 52.1875C271.579 49.8803 271.43 46.5425 269.123 47.1321C266.815 47.7217 266.374 49.0446 265.441 48.4088C264.508 47.773 257.017 46.3169 256.146 43.3995C255.31 40.6 252.936 38.18 252.152 41.7793Z",
    fill: "#FFB59E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.134 64.5902L225.194 62.7598",
    stroke: "#6C7A9E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.578 67.8304L226.638 65.9641",
    stroke: "#6C7A9E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.799 71.2862L228.325 69.1379",
    stroke: "#6C7A9E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.618 79.0694L232.397 77.9465",
    stroke: "#6C7A9E",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.277 65.3408C266.277 65.3408 265.546 64.644 265.532 66.1098C265.518 67.5757 264.407 80.0925 264.407 80.0925",
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.277 65.3408C266.277 65.3408 265.546 64.644 265.532 66.1098C265.518 67.5757 264.407 80.0925 264.407 80.0925",
    stroke: "#00A9E0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.519 87.2395C265.287 87.598 267.011 86.4557 267.369 84.688C267.728 82.9203 266.586 81.1966 264.818 80.838C263.05 80.4794 261.326 81.6217 260.968 83.3895C260.609 85.1572 261.752 86.8809 263.519 87.2395Z",
    fill: "white",
    stroke: "#C3BEC0",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.41 82.9012C266.41 82.9012 263.759 93.0512 267.441 95.3041",
    stroke: "#C1BEBF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.161 85.8535C272.161 85.8535 269.561 94.0607 264.787 93.9655",
    stroke: "#C1BEBF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.205 94.4108L263.517 94.2297C263.26 94.1653 263.105 93.8542 263.162 93.5431C263.22 93.2264 263.478 93.0305 263.731 93.0946L264.419 93.2756C264.677 93.34 264.832 93.6512 264.774 93.9623C264.717 94.2735 264.459 94.4749 264.205 94.4108Z",
    fill: "#C1BEBF",
    stroke: "#C1BEBF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.319 96.4114L267.657 96.1104C267.411 96.0026 267.29 95.6662 267.388 95.3636C267.481 95.0606 267.758 94.9049 268.004 95.0183L268.666 95.3193C268.911 95.4271 269.033 95.7635 268.935 96.0661C268.838 96.3688 268.56 96.5244 268.319 96.4114Z",
    fill: "#C1BEBF",
    stroke: "#C1BEBF",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.489 82.6144C266.489 82.6144 267.636 75.1321 272.148 77.2057C272.148 77.2057 275.403 63.6636 276.279 61.1412C277.156 58.6187 275.923 60.2963 275.923 60.2963",
    stroke: "#00A9E0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.32 85.6235C272.32 85.6235 275.97 79.976 272.07 77.2163",
    stroke: "#00A9E0",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.323 80.5614C297.153 78.9309 288.904 77.0288 290.38 66.0309C291.852 55.033 281.054 45.2144 281.054 45.2144C276.147 36.575 274.968 20.2756 257.981 29.9968C257.981 29.9968 242.589 36.7513 251.011 46.9459L252.341 48.2756L251.998 42.7328C251.998 42.7328 260.74 48.9316 265.98 48.5727C265.98 48.5727 266.41 48.6035 267.544 47.7575C267.826 47.5473 268.302 47.3832 268.713 47.2499C269.943 46.85 271.317 47.0499 270.979 49.6853C270.979 49.6853 270.902 50.6697 269.743 52.6078C268.584 54.5459 272.73 59.7999 272.73 59.7999C272.73 59.7999 282.033 85.3707 293.323 80.5614Z",
    fill: "#364851"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.291 124.286C299.83 124.286 297.835 122.292 297.835 119.831V85.6064C297.835 83.1454 299.83 81.1509 302.291 81.1509C304.752 81.1509 306.746 83.1454 306.746 85.6064V119.831C306.746 122.292 304.752 124.286 302.291 124.286Z",
    fill: "#A09F9F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.558 58.4221C217.702 58.4221 217.819 58.3051 217.819 58.1607C217.819 58.0162 217.702 57.8992 217.558 57.8992C217.414 57.8992 217.296 58.0162 217.296 58.1607C217.296 58.3051 217.414 58.4221 217.558 58.4221Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.358 58.053C220.503 58.053 220.62 57.9359 220.62 57.7915C220.62 57.6471 220.503 57.53 220.358 57.53C220.214 57.53 220.097 57.6471 220.097 57.7915C220.097 57.9359 220.214 58.053 220.358 58.053Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 115,
    width: 178,
    height: 14,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 129,
    width: 167,
    height: 18,
    fill: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18.682,
    height: 38.0651,
    rx: 4,
    transform: "matrix(0.963899 0.264501 -0.249457 0.968081 60.4957 37.9999)",
    fill: "#EDEDED"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.99152,
    transform: "matrix(0.963583 0.265842 -0.248449 0.96838 63.6285 45.5201)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.1058 47.4461C64.2098 47.7492 65.3284 47.1269 65.6042 46.0561C65.88 44.9853 65.2085 43.8715 64.1045 43.5684C64.7085 44.3397 65.3544 46.1951 63.1058 47.4461Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.99153,
    transform: "matrix(0.963582 0.265843 -0.248448 0.96838 61.4059 53.8153)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8831 55.7412C61.9871 56.0444 63.1057 55.4221 63.3815 54.3513C63.6573 53.2805 62.9858 52.1667 61.8818 51.8635C62.4858 52.6349 63.1316 54.4903 60.8831 55.7412Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.99152,
    transform: "matrix(0.963583 0.265841 -0.248449 0.96838 56.9604 70.4058)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4376 72.3318C57.5417 72.635 58.6603 72.0127 58.9361 70.9419C59.2119 69.8711 58.5404 68.7573 57.4364 68.4541C58.0404 69.2254 58.6862 71.0809 56.4376 72.3318Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.99152,
    transform: "matrix(0.963583 0.265841 -0.248449 0.96838 59.1831 62.1106)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.6604 64.0365C59.7644 64.3397 60.883 63.7174 61.1588 62.6466C61.4346 61.5758 60.7631 60.462 59.6591 60.1588C60.2631 60.9302 60.909 62.7856 58.6604 64.0365Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.99152,
    transform: "matrix(0.963583 0.265842 -0.248449 0.96838 72.4118 47.8735)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.889 49.7995C72.9931 50.1026 74.1117 49.4803 74.3875 48.4095C74.6633 47.3387 73.9918 46.2249 72.8878 45.9218C73.4918 46.6931 74.1376 48.5485 71.889 49.7995Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.99152,
    transform: "matrix(0.963583 0.265842 -0.248449 0.96838 70.1891 56.1688)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6663 58.0948C70.7704 58.3979 71.889 57.7756 72.1648 56.7048C72.4405 55.634 71.7691 54.5202 70.665 54.217C71.269 54.9884 71.9149 56.8438 69.6663 58.0948Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.9915,
    transform: "matrix(0.963583 0.26584 -0.24845 0.968379 65.7437 72.7592)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2209 74.6852C66.325 74.9884 67.4436 74.3661 67.7193 73.2953C67.9951 72.2245 67.3237 71.1107 66.2196 70.8075C66.8236 71.5788 67.4695 73.4343 65.2209 74.6852Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.05485,
    ry: 1.99152,
    transform: "matrix(0.963583 0.265842 -0.248449 0.96838 67.9664 64.4641)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.4436 66.3899C68.5477 66.6931 69.6662 66.0708 69.942 65C70.2178 63.9292 69.5464 62.8154 68.4423 62.5122C69.0463 63.2835 69.6922 65.139 67.4436 66.3899Z",
    fill: "white",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.9756,
    y: 42.3765,
    width: 13.5235,
    height: 3.07352,
    fill: "#002F6C"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.5165,
    y: 35,
    width: 18.4411,
    height: 7.99116,
    rx: 2,
    fill: "#00A9E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9576 75.4145V51.3511L54 46.4642C54 45.5645 53.2707 44.8352 52.371 44.8352H37.1031C36.2034 44.8352 35.4741 45.5645 35.4741 46.4642L35.5165 51.3511V75.4145C35.5165 76.5191 36.4119 77.4145 37.5165 77.4145H51.9576C53.0622 77.4145 53.9576 76.5191 53.9576 75.4145Z",
    fill: "#80D4EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 37.3606,
    y: 36.2295,
    width: 1.22941,
    height: 5.53234,
    fill: "#80D4EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2788,
    y: 36.2295,
    width: 1.22941,
    height: 5.53234,
    fill: "#80D4EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.5812,
    y: 36.2295,
    width: 1.22941,
    height: 5.53234,
    fill: "#80D4EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8845 36.2295H52.1139V41.7618H50.8845V36.2295Z",
    fill: "#80D4EF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2788,
    y: 74.9558,
    width: 6.76175,
    height: 1.22941,
    rx: 0.614704,
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 39.8197,
    y: 73.7267,
    width: 6.76175,
    height: 1.22941,
    rx: 0.614704,
    fill: "#FF94AE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.2788,
    y: 72.4971,
    width: 6.76175,
    height: 1.22941,
    rx: 0.614704,
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.6683,
    ry: 3.29148,
    transform: "matrix(0.827658 0.445561 -0.477055 0.786814 39.9101 69.5139)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.22568,
    height: 0.813367,
    transform: "matrix(0.813374 0.45723 -0.459974 0.789687 37.9699 67.9972)",
    fill: "#FF94AE"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 2.6683,
    ry: 3.29151,
    transform: "matrix(-0.827653 0.445559 0.477054 0.786808 44.2131 63.9816)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.25299,
    height: 0.813366,
    transform: "matrix(-0.813366 0.457231 0.459969 0.78968 46.1673 62.4563)",
    fill: "#FF94AE"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.76617,
    transform: "matrix(-1 -5.45212e-08 -1.4018e-07 1 48.733 69.1159)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.53234,
    height: 0.614704,
    transform: "matrix(-1 -5.45272e-08 -1.4016e-07 1 51.4998 68.8086)",
    fill: "#FF94AE"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 2.76617,
    transform: "matrix(-1 -5.45204e-08 -1.40181e-07 1 50.5772 60.5103)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5.53234,
    height: 0.614704,
    transform: "matrix(-1 -5.45263e-08 -1.40163e-07 1 53.3434 60.203)",
    fill: "#ED6284"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 3.29147,
    ry: 2.6683,
    transform: "matrix(-0.477055 -0.786815 -0.827659 0.445561 40.5253 54.1461)",
    fill: "#E61F50"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 6.14816,
    height: 0.546516,
    transform: "matrix(-0.463642 -0.78909 -0.819682 0.45212 42.1747 56.4484)",
    fill: "#FF94AE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4975,
    y: 53.1602,
    width: 14.9753,
    height: 8.98518,
    fill: "#FCE6EA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 21C57.8954 21 57 21.8954 57 23V26H54C52.8954 26 52 26.8954 52 28C52 29.1046 52.8954 30 54 30H57V33C57 34.1046 57.8954 35 59 35C60.1046 35 61 34.1046 61 33V30H64C65.1046 30 66 29.1046 66 28C66 26.8954 65.1046 26 64 26H61V23C61 21.8954 60.1046 21 59 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 21C57.8954 21 57 21.8954 57 23V26H54C52.8954 26 52 26.8954 52 28C52 29.1046 52.8954 30 54 30H57V33C57 34.1046 57.8954 35 59 35C60.1046 35 61 34.1046 61 33V30H64C65.1046 30 66 29.1046 66 28C66 26.8954 65.1046 26 64 26H61V23C61 21.8954 60.1046 21 59 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 21C57.8954 21 57 21.8954 57 23V26H54C52.8954 26 52 26.8954 52 28C52 29.1046 52.8954 30 54 30H57V33C57 34.1046 57.8954 35 59 35C60.1046 35 61 34.1046 61 33V30H64C65.1046 30 66 29.1046 66 28C66 26.8954 65.1046 26 64 26H61V23C61 21.8954 60.1046 21 59 21Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59 21C57.8954 21 57 21.8954 57 23V26H54C52.8954 26 52 26.8954 52 28C52 29.1046 52.8954 30 54 30H57V33C57 34.1046 57.8954 35 59 35C60.1046 35 61 34.1046 61 33V30H64C65.1046 30 66 29.1046 66 28C66 26.8954 65.1046 26 64 26H61V23C61 21.8954 60.1046 21 59 21Z",
    fill: "#E57200"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 333,
    cy: 13,
    r: 28.5,
    fill: "white",
    stroke: "#ED7B90",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333 -9L336 19H330L333 -9Z",
    fill: "#ED7B90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.27 30.7701L329.999 19.0001L335.499 16.0001L346.27 30.7701Z",
    fill: "#ED7B90"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopup);
export default __webpack_public_path__ + "static/media/Topup.fa7c7846fdbd670e78bbd367ed1dd29c.svg";
export { ForwardRef as ReactComponent };